import i18n from "../../../i18n";

export default class Collection {
  id: number;
  uid: string;
  title: string;
  groupCount: number;
  createdAt: string;
  isDefaultCollection: boolean;

  constructor(
    id: number,
    uid: string,
    title: string,
    groupCount: number,
    createdAt: string
  ) {
    this.id = id;
    this.uid = uid;
    this.title = title;
    this.groupCount = groupCount;
    this.createdAt = createdAt;
    this.isDefaultCollection = id === 0;
  }

  static fromJson(json: any): Collection {
    let id: number = json.id ?? 0;
    let uid: string = json.uid ?? "";
    let title: string = json.title ?? "";
    let groupCount: number = json.groupCount ?? 0;
    let createdAt: string = json.createdAt ?? "";
    return new Collection(id, uid, title, groupCount, createdAt);
  }
}

export function getDefaultCollection(groupCount: number): Collection {
  return new Collection(
    0,
    "",
    i18n.t("CollectionDefaultItemTitle"),
    groupCount,
    ""
  );
}
